<template>
	<v-sheet elevation="0">
		<div v-if="printedMatter.document_type != 'customer_order'"></div>
		<template v-else>
			<DeliverySlip
				v-if="printedMatter.component_name == 'DeliverySlip'"
				:printedMatter="printedMatter"
				:item="item"
				@save-and-redirect="saveAndRedirect($event)"
			/>
			<InvoiceSlip
				v-if="printedMatter.component_name == 'InvoiceSlip'"
				:printedMatter="printedMatter"
				:item="item"
				:render_data="render_data"
				@save-and-redirect="saveAndRedirect($event)"
			/>
			<Dispatch
				v-if="printedMatter.component_name == 'DispatchSlip'"
				:printedMatter="printedMatter"
				:item="item"
				@save-and-redirect="saveAndRedirect($event)"
			/>
		</template>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"

export default {
	components: {
		DeliverySlip: () => import("./customer_orders/DeliverySlip.vue"),
		InvoiceSlip: () => import("./customer_orders/InvoiceSlip.vue"),
		Dispatch: () => import("./customer_orders/DispatchSlip.vue"),
	},
	data() {
		return {
			id: this.$route.params.id,
			model_id: this.$route.query.model_id,
			printedMatter: { id: null, document_type: null, component_name: null, name: null },
			componentName: null,
			item: null,
			common,
		}
	},
	mounted() {
		this.fetchPrintedMatter()
	},
	methods: {
		fetchPrintedMatter() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/printed_matters/${this.id}`
			axios
				.get(url, { params: { model_id: this.model_id }, headers })
				.then((res) => {
					this.printedMatter = res.data.printed_matter
					if (this.printedMatter.document_type == "customer_order") {
						this.item = res.data.item
						this.render_data = res.data.render_data
						return
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		saveAndRedirect(params) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/printed_matters/${this.printedMatter.id}/printed_matter_records`
			axios
				.post(url, params, { headers })
				.then((res) => {
					this.$router.push({
						name: "printed_matter_record_index",
						params: { printed_matter_id: this.id },
						query: { ids: res.data },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
